import React from 'react';
import { config } from '@triare/auth-redux';
import Layout from '../../components/Layout';
import CreateSuccess from '../../components/Pages/CreateAccount/CreateSuccess';

const { displayName } = config;

export default function AccountCreatedSuccessfully(): React.ReactElement {
  document.title = `${displayName}: Create Account Successfully`;

  return (
    <Layout>
      <CreateSuccess />
    </Layout>
  );
}
